export enum CategoryActionTypes {
  API_RESPONSE_SUCCESS = "@@category/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@category/API_RESPONSE_ERROR",

  CREATE_CATEGORY = "@@category/CREATE_CATEGORY",
  GET_CATEGORY = "@@category/GET_CATEGORY",
  UPDATE_CATEGORY = "@@category/UPDATE_CATEGORY",
  DELETE_CATEGORY = "@@category/DELETE_CATEGORY",
  GET_CATEGORY_BY_ID = "@@category/GET_CATEGORY_BY_ID",
}
